<template>
  <div class="file-upload">
    <label class="upload-area">
      <input type="file" accept="image/*" class="file-input" @change="handleFileChange">
      <template v-if="previewUrl && isUploaded">
        <img :src="previewUrl" class="preview-image" alt="预览图">
        <!-- <button class="remove-btn" @click.stop="removeImage">×</button> -->
      </template>
      <template v-else>
        <span><i class="upload-icon"></i>{{ placeholder }}</span>
      </template>
    </label>
    <!-- 新增进度条 -->
    <div v-if="uploadProgress > 0 && uploadProgress < 100" class="progress-container">
      <div class="progress-bar" :style="{ width: uploadProgress + '%' }"></div>
      <span class="progress-text"></span>
    </div>
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',
  props: {
    placeholder: {
      type: String,
      default: '點擊或拖拽文件到此處'
    }
  },
  data() {
    return {
      previewUrl: null,
      selectedFile: null,
      error: null,
      uploadProgress: 0,
      isUploaded: false // 新增上传状态标识
    }
  },
  methods: {
    async uploadImage(file) {
      const formData = new FormData();
      formData.append('space', 'cs');
      formData.append('isReduce', true);
      formData.append('imageFile', file);

      try {
        if (!navigator.onLine) {
          throw new Error('网络连接不可用，请检查网络设置');
        }

        const controller = new AbortController();
        const xhr = new XMLHttpRequest();

        // 监听上传进度
        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) {
            this.uploadProgress = Math.round((event.loaded / event.total) * 100);
          }
        });

        return new Promise((resolve, reject) => {
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              this.uploadProgress = 0; // 上传完成重置进度
              if (xhr.status === 200) {
                resolve(JSON.parse(xhr.responseText));
              } else {
                reject(new Error(`上傳失敗: ${xhr.status} ${xhr.statusText}`));
              }
            }
          };

          xhr.open('POST', 'https://upload.dustyx.com/api/image/upload', true);
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.send(formData);
        });

      } catch (error) {
        this.uploadProgress = 0; // 出错重置进度
        throw error;
      }
    },

    async handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 验证文件类型和大小
      if (!file.type.match('image.*')) {
        this.error = '請上傳圖片文件';
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        this.error = '圖片大小不能超過20MB';
        return;
      }

      this.selectedFile = file;
      this.error = null;
      this.isUploaded = false; // 重置上传状态

      // 创建预览图但不显示
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);

      try {
        const uploadResult = await this.uploadImage(file);
        this.isUploaded = true; // 上传成功后才显示预览图
        this.$emit('uploaded', uploadResult);
        this.$emit('change', file);
      } catch (error) {
        this.error = error.message;
        this.removeImage();
      }
    },
    removeImage() {
      this.previewUrl = null;
      this.selectedFile = null;
      this.isUploaded = false; // 确保重置上传状态
      this.uploadProgress = 0; // 重置进度条
      this.error = null; // 清除错误信息
      this.$emit('change', null);
      // 重置文件输入，允许重复选择同一文件
      const fileInput = this.$el.querySelector('.file-input');
      if (fileInput) {
        fileInput.value = '';
      }
    }
  }
}
</script>

<style scoped>
.progress-container {
  margin-top: 10px;
  height: 8px;
  background: #f0f0f0;
  border-radius: 10px;
  position: relative;
}

.progress-bar {
  height: 100%;
  background: #03d2ff;
  border-radius: 10px;
  transition: width 0.3s ease;
}

.progress-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #333;
  font-size: 12px;
}

.file-upload {
  border: 2px dashed #e0e0e0;
  border-radius: 6px;
  padding: 20px;
  transition: all 0.3s;
  position: relative;
}

.file-upload:hover {
  border-color: #03d2ff;
  background: #f5fdff;
}

.upload-area {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  margin-bottom: 0px !important;
  cursor: pointer;
}

.upload-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 40px;
  margin-right: 10px;
  vertical-align: middle;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2303d2ff'%3E%3Cpath d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'/%3E%3C/svg%3E");
  background-size: 30px;
  background-position: center;
  background-repeat: no-repeat;
}

.file-input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.preview-image {
  max-width: 100%;
  max-height: 200px;
  border-radius: 4px;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(243, 31, 28, 0.8);
  color: white;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
}

.remove-btn:hover {
  background: rgba(243, 31, 28, 1);
  transform: scale(1.1);
}

.error-message {
  color: #f31f1c;
  font-size: 14px;
  margin-top: 8px;
}

@media (max-width: 768px) {
  .upload-icon {
    width: 30px;
    height: 30px;
  }
}
</style>